import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import abmActions from "../../../../redux/actions/abm.actions";
import Form from "../../../controllers/abmSintetico/Form";

const _FormAbm = ({fmk, ...props}) => {
  //console.log(props)

  const { getSchema, schema, config } = props;

  const [state, setState] = useState({loaded: false, actionFn: () => {}})
  const handleOnChangeConfirm = (result) => {
    fmk.setValues(result);
    fmk.submitForm();
  }
  
  useEffect(()=>{
    if (!schema) 
      getSchema();
  }, [schema])

  useEffect(()=>{
    setState({...state, loaded: true});
  }, [])

  return (
    <>
      {state.loaded && schema &&
        <Form {...props}  config={{...config, ...schema, columns: config.columnsAsync(schema)}} onChangeConfirm={handleOnChangeConfirm} action={fmk.values.id === 0  ? "add" : "edit"} id={fmk.values.id}/>
      }
    </>
  )
}

const mapStateToProps = (controller, action) => (state) => {
  //console.log(state.config.controllers)
  //console.log(state.config.controllers.find(x => x.name === controller && x.action === action))
  return {
    controller,
    auth: state.auth,
    config: state.config.controllers.find(x => x.name === controller && x.action === action),
    snack: state.config.snack,
    ...state[controller],
  };
}

const mapDispatchToProps = (controller) => ({
  ...abmActions(controller)
});

export const FormAbm = (controller, action) => connect(mapStateToProps(controller, action), mapDispatchToProps(controller, action))(_FormAbm);

